// src/services/UserPrefService.js
//
// A person's own dashboard settings.
//
// Distinct from the display settings under Admin, which configure the hallway
// screen for everyone. These follow the individual: someone who only wants to
// see Denmark, or wants the screen to stop moving while they read it.
//
// Stored server-side against their Entra object id rather than in the browser,
// so the choice follows them between machines.

import apiClient from './apiClient'

export async function getMyDisplayPref() {
  const response = await apiClient.post('/GetMyDisplayPref', {})

  if (response.data?.status !== 'success') {
    throw new Error(response.data?.message ?? 'Could not read your settings')
  }

  return {
    rotate: response.data.rotate !== false,
    pinnedCountry: response.data.pinned_country || ''
  }
}

export async function setMyDisplayPref({ rotate, pinnedCountry }) {
  const response = await apiClient.post('/SetMyDisplayPref', {
    rotate,
    pinned_country: pinnedCountry || ''
  })

  if (response.data?.status !== 'success') {
    throw new Error(response.data?.message ?? 'Could not save your settings')
  }
}
